module.exports = __webpack_public_path__ + "assets/img/smartTV3-icon2.047cab00.svg";